import { render, staticRenderFns } from "./EmbedEdit.vue?vue&type=template&id=25904ea0&"
import script from "./EmbedEdit.vue?vue&type=script&lang=js&"
export * from "./EmbedEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports